<template>
  <div class="pan-controls">
    <div class="pan-controls-container">
      <button class="pan-button pan-button--up" @click="pan('ArrowUp')">
        ▲
      </button>
      <button class="pan-button pan-button--right" @click="pan('ArrowRight')">
        ▲
      </button>
      <button class="pan-button pan-button--down" @click="pan('ArrowDown')">
        ▲
      </button>
      <button class="pan-button pan-button--left" @click="pan('ArrowLeft')">
        ▲
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "pan-controls",
  methods: {
    pan(direction) {
      this.$emit("pan", direction);
    },
  },
};
</script>